<div class="row m-0" style="overflow: hidden;">
    <div class="col-6">
        <div class="row mt-5">
            <div class="col-2"></div>
            <div class="col">
                <img src="../../assets/img/outlive-chat.svg" width="150">
                <div style="margin-top: 8rem;">
                    <div class="header-content">
                        Forgot Password
                    </div>
                    <div class="mt-2 font-13" style="color: #3F3C3C;">Enter your email address to reset your password</div>
                    <div class="mt-4 card border-0" id="userform">
                        <mat-form-field appearance="outline" class="w-100 full-border">
                            <mat-label>Email</mat-label>
                            <input matInput [(ngModel)]="email">
                        </mat-form-field>
                    </div>
                    <button class="btn w-100 mt-5" style="background-color: var(--primary-btn-color);color: white;height: 55px;border-radius: 7px;" [disabled]="!email" (click)="forgotPassword()"><b>Submit</b></button>
                    <div class="text-center primary-txt mt-4 cursor" (click)="serviceManager.goBack()">Back</div>
                </div>
            </div>
            <div class="col-2"></div>
        </div>
    </div>
    <div class="col-6 p-0">
        <img class="halfweb-image" src="../../assets/img/signup_bg2.jpg">
    </div>
</div>